import { UrlsList } from '../job';

export const UrlsResults = ({ job }) => {
  return <UrlsList urls={job?.results?.hits || []} job={job} />;
};
